import { FadeUp, Eyebrow } from "./Reveal";
import { Check } from "lucide-react";
import { useLang } from "@/i18n";

const WHY = ["why_1", "why_2", "why_3", "why_4"];

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="relative py-24 sm:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-8">
          <FadeUp className="lg:col-span-7 sketch-border bg-[#FFFFFF] p-8 sm:p-12 shadow-[6px_6px_0_#8B5CF6]">
            <Eyebrow>{t("about_eyebrow")}</Eyebrow>
            <h2 className="mt-5 font-serif-display font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight text-[#2B0A4E]" data-testid="about-heading">
              {t("about_h1")}{" "}
              <span className="italic gold-highlight">{t("about_h2")}</span>
            </h2>
            <p className="mt-6 text-base sm:text-lg text-[#5E4783] leading-relaxed max-w-2xl" data-testid="about-body">
              {t("about_body")}
            </p>
          </FadeUp>

          <div className="lg:col-span-5 flex flex-col gap-8">
            <FadeUp delay={0.15} className="sketch-border bg-[#2B0A4E] p-8 sm:p-10">
              <p className="font-serif-display italic text-xl sm:text-2xl text-[#FDFBF5] leading-snug" data-testid="about-quote">
                "{t("about_quote")}"
              </p>
            </FadeUp>
            <FadeUp delay={0.25} className="sketch-border bg-[#FFFFFF] p-6 sm:p-8 flex-1">
              <ul className="space-y-4">
                {WHY.map((k, i) => (
                  <li key={k} data-testid={`about-why-${i + 1}`} className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#F2C230] flex items-center justify-center shrink-0 mt-0.5">
                      <Check size={13} className="text-[#2B0A4E]" />
                    </span>
                    <span className="text-sm sm:text-base text-[#2B0A4E]/85 leading-relaxed">{t(k)}</span>
                  </li>
                ))}
              </ul>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}
